webpackJsonp([212839066777427],{

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _bloomer = __webpack_require__(25);
	
	var _hero = __webpack_require__(49);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _blogModule = __webpack_require__(566);
	
	var _blogModule2 = _interopRequireDefault(_blogModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: _blogModule2.default.fill },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'libermatic. - Blog'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'News and blogs on libermatic.' })
	    ),
	    _react2.default.createElement(
	      _hero2.default,
	      data.heroImage,
	      _react2.default.createElement(
	        _bloomer.Title,
	        null,
	        'Blog'
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _blogModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'Later on, here you can read news about ',
	          _react2.default.createElement(
	            'em',
	            null,
	            'libermatic.'
	          ),
	          ' and other stuffs.'
	        )
	      )
	    )
	  );
	};
	Blog.propTypes = {
	  data: _propTypes2.default.shape({
	    heroImage: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = Blog;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"src-pages----blog-module---section---2nBU7","content":"src-pages----blog-module---content---3JkS-","smallCaps":"src-pages----blog-module---smallCaps---3GmyQ","pointers":"src-pages----blog-module---pointers---37NXg","icon":"src-pages----blog-module---icon---1y2Zs","fill":"src-pages----blog-module---fill---36P1k"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-498b0268be53b52b4e20.js